import { slideUp, slideDown } from 'es6-slide-up-down';
import AOS from 'aos';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/artdirect/ls.artdirect';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import Accordion from './lib/accordion.ts';
import vacancies from './vacancies';
import embeddedVideo from './embeddedVideo';
import homeSlider from './homeSlider';
import fixedElements from './toggleFIxedElements';
import awards from './awards';
import modals from './modal';
import searchBarFilter from './searchBarFilter';
import menu from './menu';
import share from './share';
import tabs from './tabs';
import videoModals from './videoModals';
import filters from './filters';
import typewriter from './typewriter';
import { debounce } from './helpers';
import form from './form';
import ProgramTabs from './ProgramTabs';
import testimonialFilter from './testimonialFilter';

// lazySizes.cfg.autoArtDirect = true;
lazySizes.cfg.customMedia = {
    '--sm': '(max-width: 576px)',
    '--md': '(max-width: 768px)',
    '--lg': '(max-width: 992px)',
    '--xl': '(max-width: 1200px)',
};

function slideToggle(target, duration = 500) {
    if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration);
    }

    return slideUp(target, duration);
}

document.addEventListener('DOMContentLoaded', () => {
    const bannerScroll = document.querySelector('.banner__scroll');
    if (bannerScroll) {
        bannerScroll.addEventListener('click', (e) => {
            e.preventDefault();
            const mainWrap = document.querySelector('.main-wrap');
            if (mainWrap) {
                mainWrap.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }

    const triggers = document.querySelectorAll('.js-accordion-trigger');

    vacancies.init();
    embeddedVideo.init();
    homeSlider.init();
    fixedElements.init();
    filters.init();
    awards.init();
    modals.init();
    searchBarFilter.init();
    menu.init();
    share.init();
    tabs.init();
    videoModals.init();
    typewriter.init();
    form.init();
    ProgramTabs.init();
    if (document.querySelector('.StudentTestimonailList'))
        testimonialFilter.init();

    // Add class to <body> during resizes
    let resizeTimer;
    let resizing;
    window.addEventListener(
        'resize',
        () => {
            if (!resizing) document.body.classList.add('resizing');

            resizing = true;

            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                document.body.classList.remove('resizing');
                resizing = false;
            }, 150);
        },
        { passive: true }
    );

    function sliderToggle(e) {
        const element = e.currentTarget;

        if (window.innerWidth > 600) return;

        const collapse = element.parentElement.querySelector(
            '.js-accordion-collapse'
        );

        if (collapse) {
            slideToggle(collapse, {
                duration: 500,
            });
        }
    }

    triggers.forEach((element) =>
        element.addEventListener('click', sliderToggle)
    );

    //function footerSocialMove(mediaQuery) {
    //    if (mediaQuery.matches) {
    //        document
    //            .querySelector('#colInsta')
    //            .appendChild(document.querySelector('#colSocial'));
    //        document.getElementById('colSocial').style.paddingTop = '20px';
    //    } else {
    //        document
    //            .querySelector('.col-followUs')
    //            .appendChild(document.querySelector('#colSocial'));
    //        document.getElementById('colSocial').style.paddingTop = '0px';
    //    }
    //}

    //const mediaQuery = window.matchMedia('(max-width: 576px)');
    //footerSocialMove(mediaQuery);
    //mediaQuery.addListener(footerSocialMove);

    const accordions = document.querySelectorAll('.js-accordion');
    accordions.forEach((accordion) => new Accordion(accordion));

    // Filter Search page
    function filterSelection(filter) {
        const sections = document.querySelectorAll('.search-filter');
        if (sections != null) {
            sections.forEach((section) => {
                section.classList.remove('search-filter--hidden');

                if (filter && !section.classList.contains(filter))
                    section.classList.add('search-filter--hidden');
            });
        }
    }

    const filterContainer = document.getElementById('filter');

    if (filterContainer != null) {
        filterContainer.querySelectorAll('.btn-filter').forEach((button) => {
            button.addEventListener('click', () => {
                const current = document.querySelector('.active');

                current.classList.remove('active');
                button.classList.add('active');

                const section = button.dataset.target;
                filterSelection(section);
            });
        });
    }

    const scrollToTopButton = document.querySelector('.js-back-to-top');
    if (scrollToTopButton) {
        const watchScroll = () => {
            const visibleOffset = 500;
            const visibleClass = 'back-to-top--visible';
            const visible = scrollToTopButton.classList.contains(visibleClass);

            if (!visible && window.scrollY > visibleOffset) {
                scrollToTopButton.classList.add(visibleClass);
            } else if (visible && window.scrollY <= visibleOffset) {
                scrollToTopButton.classList.remove(visibleClass);
            }
        };

        window.addEventListener('scroll', watchScroll, { passive: true });
        scrollToTopButton.addEventListener('click', (e) => {
            e.preventDefault();
            window.scroll(0, 0);
        });
    }

    // Accordion programme overview card
    const elements = document.querySelectorAll('.js-toggle-card');

    elements.forEach((element) => {
        const content = element.querySelector('.programme-overview-card');
        const button = element.querySelector(
            '.programme-overview-card__footer--accordion'
        );

        if (button) {
            button.addEventListener(
                'click',
                () => {
                    content.classList.toggle('programme-overview-card--close');
                },
                false
            );
        }
    });

    const banner = document.querySelector('.js-fixed-banner');
    if (banner) {
        const adjustMargin = () => {
            const { height: bannerHeight } = banner.getBoundingClientRect();
            document.body.style.marginTop = `${bannerHeight}px`;
        };
        window.addEventListener('resize', debounce(adjustMargin, 80, false));
        adjustMargin();
    }

    // Scroll to the #target-element on load
    if (window.location.hash) {
        const target = document.querySelector(window.location.hash);
        if (target) {
            const position =
                window.scrollY + target.getBoundingClientRect().top - 70;
            if ('scrollBehavior' in document.documentElement.style)
                window.scroll({ top: position, behavior: 'auto' });
            else window.scroll(0, position);
        }
    }

    // collapsing of floating links
    document.addEventListener('scroll', function (e) {
        var element = document.getElementById("floatingLink");
        if (typeof (element) != 'undefined' && element != null) {
            if (window.innerWidth > 767) {
                if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
                    element.classList.add("scroll-down");
                } else {
                    element.classList.remove("scroll-down");
                }
            }
        }
    });

    AOS.init({
        disable: 'mobile',
        once: 'true',
        anchorPlacement: 'center-center',
    });
});
